import { scheduleAListConstants } from "./scheduleAList.constants";

export const scheduleAListActions = {
	setPaging,
	setSorting,
};

function setSorting({ sortBy: [{ desc, id }] }) {
	return {
		type: scheduleAListConstants.SET_SORTING,
		isDescending: desc,
		sortBy: id,
	};
}

function setPaging({ pageIndex, pageSize }) {
	return {
		type: scheduleAListConstants.SET_PAGING,
		pageIndex,
		pageSize,
	};
}